import TROCA_SENHA from '@/graphql/mutations/TrocaSenha.gql';
import env from '@/config/env';

export const Types = {
  LOADING: 'LOADING',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
};

export default {
  namespaced: true,
  state: {
    errors: {
      status: false,
      inputError: {},
      messages: {},
    },
    loading: false,
    message: '',
  },
  getters: {
    loading: state => state.loading,
    errors: state => state.errors,
    message: state => state.message,
  },
  mutations: {
    [Types.LOADING](state, payload) {
      state.loading = { ...payload };
    },
    [Types.CHANGE_PASSWORD](state, payload) {
      state.message = payload;
    },
    [Types.CLEAR_ERROR](state) {
      state.errors = { messages: {} };
    },
    [Types.SET_ERROR](state, payload) {
      console.log(payload);
      state.errors = { ...payload };
    },
  },
  actions: {
    async changePassword({ commit, dispatch }, payload) {
      commit(Types.LOADING, { changePassword: true });
      commit(Types.CLEAR_ERROR);
      commit(Types.CHANGE_PASSWORD, '');
      try {
        const save = await env.apollo.mutate({
          mutation: TROCA_SENHA,
          variables: {
            modulo: env.revista.modulo,
            ...payload,
          },
        });

        const {
          data: { alterarSenha },
        } = save;
        commit(Types.LOADING, { changePassword: false });
        if (alterarSenha === 'true') {
          commit(Types.CHANGE_PASSWORD, 'Senha alterada com sucesso');
          return true;
        }
        dispatch('setError', {
          messages: Object.assign({}, { 0: alterarSenha }),
          inputError: { senhaAtual: true },
          status: true,
        });
        return false;
      } catch (e) {
        const { graphQLErrors } = e;
        const [error] = graphQLErrors;
        switch (error.message) {
          case 'validation':
            dispatch('setError', {
              messages: error.validation.novaSenha,
              inputError: { novaSenha: true },
              status: true,
            });
            break;
          default:
            dispatch('setError', null);
        }
        commit(Types.LOADING, { changePassword: false });
      } finally {
        commit(Types.LOADING, { changePassword: false });
      }
    },
    async setError({ commit }, messages) {
      commit(Types.SET_ERROR, messages);
    },
    clearAll({ commit }) {
      commit(Types.CLEAR_ERROR);
      commit(Types.CHANGE_PASSWORD, '');
    },
  },
};
